// extracted by mini-css-extract-plugin
module.exports = {"root":"Vote-module__root___EeJuh","icon":"Vote-module__icon___1m68G","iconActive":"Vote-module__iconActive___2DfeR"};